<div style="padding: 24px">
	<h2 mat-dialog-title class="toolbar-color" style="margin-bottom: 0px">{{ 'NEW_SECURE_MESSAGE' | translate }}</h2>
	<div mat-dialog-content class="my-content" style="max-height: 100vh; font-size: 14px">
		<div
			class="phone-area"
			[formGroup]="newMessageForm"
			novalidate
			#myNewMessageForm
			style="display: flex; flex-flow: column"
		>
			<div style="width: 100%; margin-top: 10px">
				<mat-form-field appearance="outline" style="width: 100%">
					<mat-label>{{ 'SUBJECT' | translate }}</mat-label>
					<mat-select formControlName="subject" [required]="true" #subjectselect (focus)="gainedFocus()">
						<mat-option *ngFor="let subject of subjects" [value]="subject.conversationCategoryId">
							{{ subject.languageKey | translate }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="showErrorMessages && newMessageForm.controls['subject']?.invalid"
						class="large-text"
						>{{ 'SUBJECT_ERROR' | translate }}</mat-error
					>
				</mat-form-field>
			</div>
			<div style="width: 100%">
				<mat-form-field *ngIf="accounts?.length > 0" appearance="outline" style="width: 100%">
					<mat-label>{{ 'REGARDING' | translate }}</mat-label>
					<mat-select formControlName="regarding" [required]="true" #regardingselect (focus)="gainedFocus()">
						<mat-option *ngFor="let acct of accounts" [value]="acct">
							{{ acct.fullname }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="showErrorMessages && newMessageForm.controls['regarding']?.invalid"
						class="large-text"
						>{{ 'REGARDING_ERROR' | translate }}</mat-error
					>
				</mat-form-field>
			</div>
			<div class="pb-8" style="width: 100%">
				<label id="radio-group-label" style="padding: 5px 0">{{ 'CONTACT_PREFERENCE' | translate }}</label>
				<mat-radio-group
					formControlName="contactChoice"
					style="display: flex; flex-direction: column"
					(change)="showPhone()"
					[ngClass]="{ 'error-red': newMessageForm.controls['contactChoice']?.invalid && showErrorMessages }"
				>
					<mat-radio-button
						style="margin: 5px 0px 0px 5px; height: 30px"
						*ngFor="let type of convResponseTypes"
						[value]="type.conversationResponseTypeId"
					>
						{{ type.languageKey | translate }}
					</mat-radio-button>
				</mat-radio-group>
				<span style="font-size: 75%">
					<mat-error
						*ngIf="showErrorMessages && newMessageForm.controls['contactChoice']?.invalid"
						class="large-text"
						style="padding: 6px 0 0 12px"
						>{{ 'CONTACT_PREFERENCE_ERROR' | translate }}</mat-error
					>
				</span>
			</div>
			<div style="width: 100%" *ngIf="newMessageForm?.controls['contactChoice']?.value == 2">
				<div style="width: 100%; display: flex; flex-flow: row wrap">
					<mat-form-field
						appearance="outline"
						style="width: 100%"
						[ngClass]="{
							'error-red': newMessageForm.controls['phoneNumber']?.invalid && showErrorMessages
						}"
					>
						<mat-label>{{ 'CONVERSATION_PHONE' | translate }}</mat-label>
						<input
							matInput
							type="text"
							formControlName="phoneNumber"
							required
							value=""
							mask="(000) 000-0000"
							[showMaskTyped]="true"
						/>
						<mat-error
							*ngIf="showErrorMessages && newMessageForm.controls['phoneNumber']?.invalid"
							class="large-text"
							>{{ 'PHONENUMBER_ERROR' | translate }}</mat-error
						>
					</mat-form-field>
				</div>
				<div style="width: 100%">
					<mat-form-field *ngIf="contactTimes.length > 0" appearance="outline" style="width: 100%">
						<mat-label>{{ 'PREFERRED_CONTACT_TIME' | translate }}</mat-label>
						<mat-select formControlName="contactTime" [required]="true" #timeselect (focus)="gainedFocus()">
							<mat-option *ngFor="let ct of contactTimes" [value]="ct.contactTimeId">
								{{ ct.description }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>

			<div class="pb-8" style="width: 100%; margin: 5px 0px">
				<mat-form-field class="" appearance="outline" style="width: 100%">
					<mat-label>{{ 'TYPE_MESSAGE_HERE' | translate }}</mat-label>
					<textarea
						#msgTextarea
						maxlength="1000"
						matInput
						style="min-height: 80px"
						formControlName="message"
						required
					></textarea>
					<mat-hint align="end">{{ msgTextarea.value?.length || 0 }} / 1000</mat-hint>
					<mat-error
						*ngIf="showErrorMessages && newMessageForm.controls['message']?.invalid"
						class="large-text"
						>{{ 'MESSAGE_ERROR' | translate }}</mat-error
					>
				</mat-form-field>
			</div>
		</div>

		<div class="button-row">
			<div class="half-row-item">
				<button
					id="new-msg-send-btn"
					style="font-size: 14px; color: #fdfefe"
					mat-raised-button
					(click)="createMessage()"
					class="a-button"
					[disabled]="disableSubmit"
				>
					{{ 'SEND' | translate }}
				</button>
			</div>
			<div class="half-row-item-column">
				<button
					style="font-size: 14px"
					mat-stroked-button
					class="a-button"
					(click)="this.dialogRef.close(false)"
				>
					{{ 'CANCEL' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
